'use client';

import { useEffect, useState } from 'react';

import { appWithTheme } from '@scorenco/components';
import {
  ApolloService,
  SentryService,
  CrispService,
  ApolloServiceProps,
} from '@scorenco/core';
import {
  AppLayout,
  AppPropsWithLayout,
  DefaultLayout,
  NextGoogleAnalyticsService,
} from '@scorenco/next';
import { AppProps } from 'next/app';

import { ErrorComponent, GlobalSeo } from '../components';
import { routerConfig } from '../routes';

DefaultLayout.init({
  i18n: {
    i18n: {
      defaultLocale: 'fr',
      locales: ['fr' /*'de'*/],
    },
    fallbackLng: ['fr' /*'de'*/],
  },
  router: {
    baseUrl: process.env.NEXT_PUBLIC_WEB_URL,
    config: routerConfig,
  },
  amplify: {},
});
CrispService.init();

const App = (appProps: AppProps<ApolloServiceProps>) => {
  const { pageProps } = appProps;
  const [enableCrisp, setEnableCrisp] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(
        () => {
          setEnableCrisp(true);
        },
        { timeout: 3000 }
      );
    } else {
      timeoutId = setTimeout(() => {
        setEnableCrisp(true);
      }, 3000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  // On ne veut pas de Crisp et de la validation des cookies sur l'overlay d'un
  // live et la couleur du html et body en transparent
  if (
    typeof window !== 'undefined' &&
    window.location.pathname.includes('overlay')
  ) {
    return (
      <SentryService Fallback={ErrorComponent}>
        <ApolloService initialApolloState={pageProps.initialApolloState}>
          <AppLayout
            {...(appProps as AppPropsWithLayout<ApolloServiceProps>)}
          />
        </ApolloService>
      </SentryService>
    );
  }

  return (
    <SentryService Fallback={ErrorComponent}>
      {enableCrisp ? (
        <CrispService>
          <ApolloService initialApolloState={pageProps.initialApolloState}>
            <NextGoogleAnalyticsService>
              <GlobalSeo />
              <AppLayout
                {...(appProps as AppPropsWithLayout<ApolloServiceProps>)}
              />
            </NextGoogleAnalyticsService>
          </ApolloService>
        </CrispService>
      ) : (
        <ApolloService initialApolloState={pageProps.initialApolloState}>
          <NextGoogleAnalyticsService>
            <GlobalSeo />
            <AppLayout
              {...(appProps as AppPropsWithLayout<ApolloServiceProps>)}
            />
          </NextGoogleAnalyticsService>
        </ApolloService>
      )}
    </SentryService>
  );
};

export default appWithTheme(DefaultLayout.appEnhancer(App));
